<template>
    <layout :racingstars="$page.props.racingstars" :jetstream="$page.props.jetstream" :user="$page.props.user" title="Dashboard">
        <template #header>
            Dashboard
        </template>
        <div class="sm:p-6">
            <div class="py-4">
                <div v-if="processing" class="flex justify-center">
                <span class="text-gray-900 bg-racing-stars-yellow font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 inline-flex items-center">
                    <svg role="status" class="inline mr-3 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#000001"/>
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                    </svg>
                    Loading...
                </span>
                </div>
                <div v-else>


                    <div v-for="(data, name) in stats" :key="name" class="mb-4">
                        <div>
                            <h3 class="text-lg leading-6 font-medium text-gray-900 dark:text-white">
                                {{ toTitleCase(name) }} in the Last 30 days
                            </h3>
                            <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
                                <div v-for="(item, name) in data" :key="name" class="px-4 py-5 bg-white shadow rounded-lg overflow-hidden sm:p-6">
                                    <dt class="text-sm font-medium text-gray-500 truncate">
                                        {{ toTitleCase(name) }}
                                    </dt>
                                    <dd class="mt-1 text-3xl font-semibold text-gray-900">
                                        {{ item.total.toFixed(2) }}
                                    </dd>
                                    <dd v-if="item.value !== undefined" class="mt-1 text-3xl font-semibold text-gray-900">
                                        {{ formatter.format(item.value / 100) }}
                                    </dd>
                                </div>
                            </dl>
                        </div>
                    </div>


                </div>

                <!--                 <h1 class="dark:text-white text-3xl mb-4">Referrals</h1>-->

                <!--                <div v-for="user in users" class="px-4 py-5 bg-gray-100 dark:bg-gray-800 shadow rounded-lg overflow-hidden sm:p-6 mb-4">-->
                <!--                    <h2 class="dark:text-white font-bold mb-4">{{ user.name }}</h2>-->
                <!--                    <table class="border-collapse table-auto w-full divide-y divide-gray-200 table-auto">-->
                <!--                        <thead class="bg-gray-50 bg-gray-50 transition duration-500 ease-in-out dark:bg-gray-900" v-if="user.referrals.length">-->
                <!--                            <tr>-->
                <!--                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider transition duration-500 ease-in-out dark:text-white">-->
                <!--                                    Username-->
                <!--                                </th>-->
                <!--                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider transition duration-500 ease-in-out dark:text-white">-->
                <!--                                    Tokens Earned-->
                <!--                                </th>-->
                <!--                                <th scope="col" class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider transition duration-500 ease-in-out dark:text-white">-->
                <!--                                    Date Referred-->
                <!--                                </th>-->
                <!--                            </tr>-->
                <!--                        </thead>-->
                <!--                        <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200">-->
                <!--                            <tr v-for="(referral, referralKey) in user.referrals" :key="referralKey" :class="referralKey % 2 === 0 ? 'bg-white transition duration-500 ease-in-out dark:bg-gray-600' : 'bg-gray-50 transition duration-500 ease-in-out dark:bg-gray-800'" class="dark:hover:bg-opacity-80">-->
                <!--                                <td class="px-6 py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white">-->
                <!--                                    <div class="text-sm  text-left text-gray-900 transition duration-500 ease-in-out dark:text-white">-->
                <!--                                        {{ referral.name }}-->
                <!--                                    </div>-->
                <!--                                </td>-->
                <!--                                <td class="px-6 py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white text-left">-->
                <!--                                    <div class="text-sm text-left font-medium text-gray-900 transition duration-500 ease-in-out dark:text-white">-->
                <!--                                        {{ isValid(user, referral) ? tokensEarned(user, referral) : 'Invalid' }}-->
                <!--                                    </div>-->
                <!--                                </td>-->
                <!--                                <td class="px-6 text-right py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white">-->
                <!--                                    <div class="text-sm text-gray-900 transition duration-500 ease-in-out dark:text-white whitespace-pre-wrap">{{ moment(referral.created_at).format('dddd, MMMM Do, YYYY') }}</div>-->
                <!--                                </td>-->
                <!--                            </tr>-->
                <!--                        </tbody>-->
                <!--                        <tfoot>-->
                <!--                            <tr>-->
                <!--                                <td colspan="3" class="px-6 text-right py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white">Total Referrals: {{ user.referral_totals.referrals }}</td>-->
                <!--                            </tr>-->
                <!--                            <tr>-->
                <!--                                <td colspan="3" class="px-6 text-right py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white">Total Tokens Earned: {{ user.referral_totals.tokens }}</td>-->
                <!--                            </tr>-->
                <!--                        </tfoot>-->
                <!--                    </table>-->
                <!--                </div>-->
            </div>
        </div>
    </layout>
</template>
<script>
import Layout from '@/Layouts/Layout'
import TwCard from '@/Global/Elements/TwCard'
import moment from 'moment'
import {onMounted, ref} from "vue";

export default {
    props: {
    },
    components: {
        Layout,
        TwCard,
    },
    setup(props) {
        const stats = ref([])
        const processing = ref(true)
        const getStats = () => {
            processing.value = true
            axios.get(route('api.stats.index'))
                .then(response => {
                    console.log(response);
                    stats.value = response.data
                    processing.value = false
                })

            console.log(stats.value)
        }

        const formatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
        })

        const toTitleCase = (str) => {
            return str.replace(/^_*(.)|_+(.)/g, (s, c, d) => c ? c.toUpperCase() : ' ' + d.toUpperCase())
        }

        const tokensEarned = (user, referral) => {
            let playTokens = 0;

            user.reports.some(e => {
                let data = JSON.parse(e.data)

                if (data.user.id === referral.id && data.valid) {
                    playTokens = data.play_tokens
                }
            })

            return playTokens
        }

        const isValid = (user, referral) => {
            let valid = false;

            user.reports.some(e => {
                let data = JSON.parse(e.data)

                if (data.user.id === referral.id && data.valid) {
                    valid = true
                }
            })

            return valid
        }




        onMounted(() => {
            getStats()
        })
        return {
            stats,
            processing,
            formatter,
            toTitleCase,
            tokensEarned,
            isValid,
            moment,
        }
    }
}
</script>
